var _circle, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewLessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.8,
    stroke: "white",
    strokeWidth: 2.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.19971,
    y1: 11.8781,
    x2: 16.7997,
    y2: 11.8781,
    stroke: "white",
    strokeWidth: 2.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewLessIcon);
export default __webpack_public_path__ + "static/media/view_less_icon.5cf30013a59dac2fb05ba7f06903c6ed.svg";
export { ForwardRef as ReactComponent };